import FileIcon from '../../utility/Attach_doc/file.png'

const Attachmentlist = ({ list = [], onDocClick }) => {

  const handleDocClick = (doc) => {
    if (onDocClick) {
      onDocClick(doc);
    }
  };

  return (
    <div className="row" style={{ width: "100%" }}>
      {list.length > 0 &&
        list.map((doc) => (
          <div
            className="col-md-3"
            key={doc.attachmentid}
            onClick={() => handleDocClick(doc)}
            style={{
              padding: "10px 5px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="docdiv" style={{ cursor: "pointer" }}>
              <div className="main">
                <img src={FileIcon} alt="" />
                <span
                  style={{
                    fontSize: doc.extension.length > 4 ? "10px" : "18px",
                  }}
                >
                  {doc.extension}
                </span>
              </div>

              <div className="bottom">
                <span className="docname">{doc.filename}</span>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default Attachmentlist;